import { Component, input, output, ChangeDetectionStrategy } from '@angular/core';
import { LinkClickEvent } from 'src/app/controls/models/control-event.model';
import { NgClass } from '@angular/common';
import { SvgIconComponent } from '../svg-icon/svg-icon.component';

@Component({
  selector: 'app-link',
  templateUrl: './link.component.html',
  styleUrls: ['./link.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgClass, SvgIconComponent]
})
export class LinkComponent {
  icon = input<string>('');
  iconClass = input<string>('');
  disabled = input<boolean>(false);
  onClickEvent = output<LinkClickEvent>({ alias: 'onClick' });

  onClick(event: unknown): void {
    if (!this.disabled()) {
      this.onClickEvent.emit(new LinkClickEvent(this));
    }
  }

}
